import { render } from "./selectbox.vue?vue&type=template&id=6a855628&scoped=true"
import script from "./selectbox.vue?vue&type=script&lang=js"
export * from "./selectbox.vue?vue&type=script&lang=js"

import "./selectbox.vue?vue&type=style&index=0&id=6a855628&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a855628"]])

export default __exports__